export const ASSET_VERSION_BASE_EVENT = `asset:version`;

export enum AssetVersionEvent {
	INIT = `${ASSET_VERSION_BASE_EVENT}:init`,
	INITIALIZED = `${ASSET_VERSION_BASE_EVENT}:initialized`,
	EXTEND = `${ASSET_VERSION_BASE_EVENT}:extend`,

	UPLOAD = `${ASSET_VERSION_BASE_EVENT}:upload`,
	EDIT = `${ASSET_VERSION_BASE_EVENT}:edit`,
}
